export default {
  results: [],

  // Request meta
  loadingCount: 0,
  lastResponseDate: null,
  requestError: null,
};
